import React from 'react'
import AnimateButton from 'jd-library/AnimateButton';
import styles from './animate-button.scss';

export default props => {
    
    const getStyles = () => {
        let styles = {
            boxShadow : '0 2px 5px 0.05px rgba(0,0,0,.02), 0 6px 10px 0 rgba(0,0,0,.05), 0 1px 18px 0 rgba(0,0,0,.1)'
        };
        if(props.customClassObj){
            Object.keys(props.customClassObj).forEach((key)=>{
                   styles[key] = props.customClassObj[key];
            })
        }
        return styles;
    }
    return (
        <AnimateButton
            style={getStyles()}
            btnText={props.btnText}
            iconClass={props.iconClass}
            onClick={props.onClick}
            btnWidth={props.btnWidth}
            buttonClass = {props.buttonClass}
            btnTextClass={`${styles['animate-btn-text']} ${props.className}`}
        />
    )
}